import { useQuery } from '@tanstack/react-query';
import { z } from 'zod';
import useAuthenticatedFetch from '@/domains/auth/hooks/authenticatedFetch';
import { useAuthContext } from '@/domains/auth/authContext';
const userTypeResponseSchema = z.object({
  userType: z.enum(['public', 'lead', 'account']),
});

type UserTypeResponse = z.infer<typeof userTypeResponseSchema>;

export const useUserTypeQuery = () => {
  const authenticatedFetch = useAuthenticatedFetch();
  const { isLoggedIn, authReady } = useAuthContext();

  // FIXME: Ideally we want to move away from using the isLoggedIn flag here as it may be causing us to
  // not correctly invalidate queries and the query invalidation itself should already allow us to
  // trigger a refetch so this should not be necessary. Reverting for now as a temporary solution as it may be causing issues in local development.
  return useQuery<UserTypeResponse>({
    queryKey: ['userType'],
    enabled: isLoggedIn && authReady,
    staleTime: 0,
    queryFn: async () => {
      const res = await authenticatedFetch('/api/auth/user-type', {
        method: 'GET',
      });
      if (!res.ok) {
        throw new Error('Failed to fetch user type');
      }
      const data = await res.json();
      return userTypeResponseSchema.parse(data);
    },
  });
};
